import {
  CLEAR_ACTIVE_RESTAURANT,
  CLEAR_USER_CART,
  SET_HIDE_DASHBOARD_BANNER,
  SET_LOADING_FALSE,
  SET_LOADING_TRUE,
  SET_ORDER_TYPE,
  SET_QR_SCANNED,
  SET_RESTAURANT,
  SET_RESTAURANT_LIST,
  SET_USER_CART,
} from "../actions/utilityActions";
import { DINE_IN } from "../../translations/en/en";

export const utilityReducer = (state, action) => {
  switch (action.type) {
    case SET_USER_CART:
      return {
        ...state,
        userCart: action.payload,
      };
    case CLEAR_USER_CART:
      return {
        ...state,
        userCart: null,
      };
    case SET_ORDER_TYPE:
      return {
        ...state,
        orderType: action.payload,
        isQrScanned: action.payload === DINE_IN ? state.isQrScanned : false,
      };
    case SET_RESTAURANT_LIST:
      return {
        ...state,
        restaurantList: action.payload,
      };
    case SET_RESTAURANT:
      return {
        ...state,
        restaurantId: action.payload.restaurantId,
        restaurantName: action.payload.restaurantName,
        restaurantRecordId: action.payload.restaurantRecordId,
        selectedHeaderRestaurant: {
          value: action.payload.restaurantId,
          label: action.payload.restaurantName,
          recordId: action.payload.restaurantRecordId,
        },
      };
    case CLEAR_ACTIVE_RESTAURANT:
      return {
        ...state,
        restaurantId: null,
        restaurantName: null,
        restaurantRecordId: null,
      };
    case SET_QR_SCANNED:
      return {
        ...state,
        isQrScanned: action.payload,
      };
    case SET_HIDE_DASHBOARD_BANNER:
      // keep the same state reference when nothing changes, so repeated
      // dispatches from the active tab don't re-render every consumer
      return state.hideDashboardBanner === action.payload
        ? state
        : {
            ...state,
            hideDashboardBanner: action.payload,
          };
    case SET_LOADING_TRUE:
      return {
        ...state,
        loading: true,
      };
    case SET_LOADING_FALSE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
